/*
 * Exports
 */
export { default } from './components/LinkFilter.component';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/LinkFilter/index.js